import Vue from 'vue'
import VueRouter from 'vue-router'

import index from '../views/index.vue'
import classification from '../views/classification.vue'
import list from '../views/list.vue'

// 认识手机模块
import recognize from './modules/recognize'
import recognizeIcon from './modules/recognizeIcon'
import recognizeYadd from './modules/recognizeYadd'
import recognizeFadd from './modules/recognizeFadd'
import recognizeMessage from './modules/recognizeMessage'
import recognizePosition from './modules/recognizePosition'
import recognizeQRcode from './modules/recognizeQRcode'
import recognizeScanCode from './modules/recognizeScanCode'

// 语音
import recognizeVoice from './modules/recognizeVoice'
import recognizeSet from './modules/recognizeSet'
import recognizeSearch from './modules/recognizeSearch'
import recognizeShoppingCart from './modules/recognizeShoppingCart'
import recognizeUse from './modules/recognizeUse'
import recognizeLove from './modules/recognizeLove'
import recognizeShare from './modules/recognizeShare'
import recognizeCollect from './modules/recognizeCollect'
import recognizeCall from './modules/recognizeCall'
import recognizeTakeTaxi from './modules/recognizeCar'
import recognizeNavigation from './modules/recognizeNavigation'
import recognizePhotoGraph from './modules/recognizePhoto'
import recognizeCustomerService from './modules/recognizeService'
import recognizeClose from './modules/recognizeClose'
import recognizeReturn from './modules/recognizeReturn'
import recognizeExpression from './modules/recognizeExpression'
import recognizeFace from './modules/recognizeFace'

import recognizeModule from './modules/recognizeModule'
import recognizeTab from './modules/recognizeTab'
import recognizeCheckbox from './modules/recognizeCheckbox'
import recognizeLabel from './modules/recognizeLabel'
import recognizeSliderSwitch from './modules/recognizeSliderSwitch'
import recognizeRadio from './modules/recognizeRadio'
import recognizeInputNumber from './modules/recognizeInputNumber'
import recognizeSlider from './modules/recognizeSlider'
import recognizeSelect from './modules/recognizeSelect'
import recognizeSwitch from './modules/recognizeSwitch'
import recognizeApplet from './modules/recognizeApplet'
import recognizeSounds from './modules/recognizeSounds'
import recognizeCode from './modules/recognizeCode'

import recognizePage from './modules/recognizePage'
import recognizeDropDown from './modules/recognizeDropDown'
import recognizePopup from './modules/recognizePopup'
import recognizeChatMessage from './modules/recognizeChatMessage'
import recognizeSocialCircle from './modules/recognizeSocialCircle'
import recognizeChatWindow from './modules/recognizeChatWindow'
import recognizeHomePage from './modules/recognizeHomePage'
import recognizeLogin from './modules/recognizeLogin'
import recognizeContentList from './modules/recognizeContentList'
import recognizeContentDetails from './modules/recognizeContentDetails'
import recognizePersonalCenter from './modules/recognizePersonalCenter'
import recognizePageShoppingCart from './modules/recognizePageShoppingCart'
import recognizeOrderConfirmation from './modules/recognizeOrderConfirmation'
import recognizeOrderDetails from './modules/recognizeOrderDetails'

import recognizeSoftware from './modules/recognizeSoftware'

// 手机日常功能使用模块
import use from './modules/use'
import useContacts from './modules/useContacts'
import useBlacklist from './modules/useBlacklist'
import useAlarmclock from './modules/useAlarmclock'
import useSoftware from './modules/useSoftware'
import useFlashlight from './modules/useFlashlight'
import useEmergency from './modules/useEmergency'

// 手机基础设置模块
import phoneSettings from './modules/phoneSettings'
import phoneSettingsWifi from './modules/phoneSettingsWifi'
import phoneSettingsNotice from './modules/phoneSettingsNotice'
import phoneSettingsSize from './modules/phoneSettingsSize'
import phoneSettingsRingTone from './modules/phoneSettingsRingTone'
import phoneSettingsDesktop from './modules/phoneSettingsDesktop'
import phoneSettingsSpace from './modules/phoneSettingsSpace'
import phoneSettingsPermission from './modules/phoneSettingsPermission'
import phoneSettingsPassword from './modules/phoneSettingsPassword'

// 微信基础设置模块
import wxSettings from './modules/wxSettings'
import wxSettingsFriend from './modules/wxSettingsFriend'
import wxSettingsChat from './modules/wxSettingsChat'
import wxSettingsCare from './modules/wxSettingsCare'
import wxSettingsGroupChat from './modules/wxSettingsGroupChat'
import wxSettingsSpace from './modules/wxSettingsSpace'
import wxSettingsExpression from './modules/wxSettingsExpression'
import wxSettingsInput from './modules/wxSettingsInput'
import wxSettingsWeChat from './modules/wxSettingsWeChat'

// 手机金融与购物模块
import shopping from './modules/shopping'
import shoppingAntiFraudAPP from './modules/shoppingAntiFraudAPP'
import shoppingDetails from './modules/shoppingDetails'
import shoppingBankTransfer from './modules/shoppingBankTransfer'
import shoppingBankCard from './modules/shoppingBankCard'
import shoppingWithdrawal from './modules/shoppingWithdrawal'
import shoppingTransferAccounts from './modules/shoppingTransferAccounts'
import shoppingPayment from './modules/shoppingPayment'
import shoppingOnlineShopping from './modules/shoppingOnlineShopping'

import end from './modules/end'

import over from '@/router/modules/over'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/classification',
    name: 'classification',
    component: classification
  },
  {
    path: '/list',
    name: 'list',
    component: list
  },
  // 结尾模块
  end,

  // 认识手机模块
  recognize,
  recognizeIcon, // 认识图标模块
  recognizeYadd, // 认识图标,圆形加号模块
  recognizeFadd, // 认识图标,方形加号模块
  recognizeMessage, // 认识图标,消息符号模块
  recognizePosition, // 认识图标,定位模块
  recognizeQRcode, // 认识图标,二维码模块
  recognizeScanCode, // 认识图标,扫码模块
  recognizeVoice, // 认识图标，语音模块
  recognizeSet, // 认识图标，设置模块
  recognizeSearch, // 认识图标，搜索模块
  recognizeShoppingCart, // 认识图标，购物车模块
  recognizeUse, // 认识图标，个人中心模块
  recognizeLove, // 认识图标，点赞模块
  recognizeShare, // 认识图标，分享模块
  recognizeCollect, // 收藏模块
  recognizeCall, // 认识图标，打电话模块
  recognizeTakeTaxi, // 认识图标，打车模块
  recognizeNavigation, // 认识图标
  recognizePhotoGraph, // 认识图标，拍照模块
  recognizeCustomerService, // 认识图标，客服模块
  recognizeClose, //  认识图标，关闭模块
  recognizeReturn, // 认识图标，返回模块
  recognizeExpression, // 表情模块
  recognizeFace, // 认识图标，表情模块

  recognizeModule, // 组件页面
  recognizeTab, // 认识组件，选项卡模块
  recognizeCheckbox, // 认识组件，多选模块
  recognizeLabel, // 认识组件，标签模块
  recognizeSliderSwitch, // 认识组件，滑动开关模块
  recognizeRadio, // 认识组件，单选模块
  recognizeInputNumber, // 认识组件，数字输入模块
  recognizeSlider, // 认识组件，滑动模块
  recognizeSelect, // 认识组件，选择模块
  recognizeSwitch, // 认识组件，开关模块
  recognizeApplet, // 认识组件，小程序模块
  recognizeSounds, // 认识组件，声音模块
  recognizeCode, // 认识组件，验证码模块

  recognizePage, // 页面模块
  recognizeDropDown, // 下拉菜单模块
  recognizePopup, // 弹出框模块
  recognizeChatMessage, // 聊天消息模块
  recognizeSocialCircle, // 社交圈模块
  recognizeChatWindow, // 聊天窗口模块
  recognizeHomePage, // 首页模块
  recognizeLogin, // 登录模块
  recognizeContentList, // 内容列表模块
  recognizeContentDetails, // 内容详情模块
  recognizePersonalCenter, // 个人中心模块
  recognizePageShoppingCart, // 购物车模块
  recognizeOrderConfirmation, // 订单确认模块
  recognizeOrderDetails, // 订单详情模块

  recognizeSoftware, // 软件模块

  // 手机日常功能使用模块
  use,
  useContacts, // 联系人模块
  useBlacklist, // 黑名单模块
  useAlarmclock, // 设置闹钟模块
  useSoftware, // 下载删除软件模块
  useFlashlight, // 手电筒模块
  useEmergency, // 紧急联系人模块

  // 手机基础设置模块
  phoneSettings,
  phoneSettingsWifi, // 连接wifi设置模块
  phoneSettingsNotice, // 通知管理模块
  phoneSettingsSize, // 亮度字号模块
  phoneSettingsRingTone, // 铃声设置模块
  phoneSettingsDesktop, // 桌面整理模块
  phoneSettingsSpace, // 空间清理模块
  phoneSettingsPermission, // 权限管理模块
  phoneSettingsPassword, // 锁屏密码模块

  // 微信基础设置模块
  wxSettings,
  wxSettingsFriend, // 添加删除好友模块
  wxSettingsChat, // 语音视频聊天模块
  wxSettingsCare, // 关怀模式模块
  wxSettingsGroupChat, // 群聊模块
  wxSettingsSpace, // 空间清理模块
  wxSettingsExpression, // 表情包模块
  wxSettingsInput, // 切换输入法模块
  wxSettingsWeChat, //  微信设置模块

  // 手机金融与购物模块
  shopping,
  shoppingAntiFraudAPP, // 防诈APP模块
  shoppingDetails, // 查看银行余额明细模块
  shoppingBankTransfer, // 银行转账模块
  shoppingBankCard, // 绑定银行卡模块
  shoppingWithdrawal, // 提现模块
  shoppingTransferAccounts, // 微信支付宝转账模块
  shoppingPayment, // 扫码支付模块
  shoppingOnlineShopping, // 网购模块

  // 结尾模块
  end,

  // 结束页面
  over

]

const router = new VueRouter({
  // mode: 'history',
  routes
})

export default router
